import React from 'react'

import { Button, ArrowRight as ArrowRightIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

function BrowseAllButton({ className = '', href = '/3d-models?page=1', text = 'Browse all models' }) {
  return (
    <Button
      type="secondary"
      size="small"
      trailIcon={<ArrowRightIcon width="16" height="16" />}
      customClass={className}
      href={href}
    >
      {text}
    </Button>
  )
}

BrowseAllButton.propTypes = {
  className: string,
  href: string,
  text: string,
}

export default BrowseAllButton
